const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

(function () {
  var sonarkThemeAssetScript = document.currentScript && document.currentScript.src;

  function ensureCanonicalLink() {
    if (!document.head || document.querySelector('link[rel="canonical"]')) return;

    var ogUrl = document.querySelector('meta[property="og:url"]');
    var canonicalHref =
      ogUrl && ogUrl.getAttribute('content')
        ? ogUrl.getAttribute('content')
        : window.location.origin + window.location.pathname;

    if (!canonicalHref) return;

    var canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', canonicalHref);
    document.head.appendChild(canonical);
  }

  function dropMarineGuidesDolphin(attempt) {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var dolphinImage = document.querySelector(
      '.sonark-start-here-v4__card img[src*="sonark-marine-guides-dolphin-original"]'
    );

    if (!dolphinImage) {
      if ((attempt || 0) < 30) {
        window.setTimeout(function () {
          dropMarineGuidesDolphin((attempt || 0) + 1);
        }, 150);
      }
      return;
    }

    dolphinImage.style.setProperty('object-fit', 'cover', 'important');
    dolphinImage.style.setProperty('object-position', '50% 25%', 'important');
  }

  function normalizeFooterDraftProductLink(attempt) {
    var oldLink = document.querySelector('a[href="/products/vhf-fleet-communication-bundle"]');

    if (!oldLink) {
      if ((attempt || 0) < 30) {
        window.setTimeout(function () {
          normalizeFooterDraftProductLink((attempt || 0) + 1);
        }, 150);
      }
      return;
    }

    oldLink.setAttribute('href', '/collections/marine-radios');
    oldLink.textContent = 'Marine Radios';
  }

  function replaceGearUpImage(attempt) {
    if (!document.body || !document.body.classList.contains('template-index')) return;

    var gearImage = document.querySelector('.sonark-water-adventure__media img');
    if (!gearImage || !sonarkThemeAssetScript) {
      if ((attempt || 0) < 30) {
        window.setTimeout(function () {
          replaceGearUpImage((attempt || 0) + 1);
        }, 150);
      }
      return;
    }

    if (gearImage.dataset.sonarkTwoDogLoading === 'true') return;
    gearImage.dataset.sonarkTwoDogLoading = 'true';

    var partRequests = [];
    for (var partNumber = 1; partNumber <= 6; partNumber += 1) {
      partRequests.push(
        fetch(new URL('sonark-gear-up-image-part-' + partNumber + '.txt', sonarkThemeAssetScript).href, {
          credentials: 'same-origin',
        }).then(function (response) {
          if (!response.ok) throw new Error('Unable to load Gear Up image');
          return response.text();
        })
      );
    }

    Promise.all(partRequests)
      .then(function (parts) {
        gearImage.src = 'data:image/jpeg;base64,' + parts.join('');
        gearImage.alt = 'Two small dogs wearing captain and sun hats in a classic wooden Sonark Marine boat';
        gearImage.dataset.sonarkTwoDogLoaded = 'true';
      })
      .catch(function () {
        delete gearImage.dataset.sonarkTwoDogLoading;
      });
  }

  function addHurricaneTracker() {
    if (!document.body || !document.body.classList.contains('template-index')) return;
    if (document.getElementById('sonark-hurricane-tracker-card')) return;

    var anchorSection = document.querySelector('[id*="collection_list_fP4t6z"]');
    if (!anchorSection) {
      var startHere = document.querySelector('.sonark-start-here-v4');
      anchorSection = startHere ? startHere.closest('.shopify-section') : null;
    }
    if (!anchorSection) return;

    var wrapper = document.createElement('section');
    wrapper.id = 'sonark-hurricane-tracker-card';
    wrapper.className = 'sonark-hurricane-tracker';
    wrapper.setAttribute('aria-label', 'Sonark Marine hurricane tracker and readiness binder');
    wrapper.innerHTML = `
      <style>
        #sonark-hurricane-tracker-card{width:100vw;margin:0 calc(50% - 50vw);background:#0e1b4d;padding:8px 18px 48px;color:#fff;font-family:Arial,Helvetica,sans-serif}
        #sonark-hurricane-tracker-card *{box-sizing:border-box}
        #sonark-hurricane-tracker-card .sht-card{max-width:1180px;margin:0 auto;display:grid;grid-template-columns:minmax(300px,.88fr) minmax(0,1.12fr);overflow:hidden;border-radius:24px;border:1px solid rgba(34,211,238,.45);background:#122965;box-shadow:0 16px 40px rgba(0,0,0,.22);color:#fff}
        #sonark-hurricane-tracker-card .sht-visual{min-height:390px;position:relative;overflow:hidden;background:#071d49}
        #sonark-hurricane-tracker-card .sht-visual img{display:block;width:100%;height:100%;min-height:390px;object-fit:cover;object-position:center}
        #sonark-hurricane-tracker-card .sht-visual:after{content:'';position:absolute;inset:0;background:linear-gradient(180deg,rgba(4,20,52,.02) 46%,rgba(4,20,52,.72) 100%);pointer-events:none}
        #sonark-hurricane-tracker-card .sht-credit{position:absolute;left:18px;bottom:15px;z-index:2;margin:0!important;padding:6px 10px;border-radius:999px;background:rgba(4,20,52,.78);color:#fff!important;font-size:12px!important;line-height:1.2!important;letter-spacing:.02em}
        #sonark-hurricane-tracker-card .sht-copy{padding:42px 38px;display:flex;flex-direction:column;justify-content:center}
        #sonark-hurricane-tracker-card .sht-eyebrow{margin:0 0 10px;color:#ffb14a!important;font-weight:900;letter-spacing:.08em;text-transform:uppercase;font-size:14px}
        #sonark-hurricane-tracker-card h2{margin:0 0 14px;color:#22d3ee!important;font-size:clamp(32px,4.4vw,54px);line-height:1.02;font-weight:950}
        #sonark-hurricane-tracker-card .sht-description{margin:0 0 24px;color:#eaf6ff!important;font-size:clamp(17px,2vw,21px);line-height:1.55;max-width:720px}
        #sonark-hurricane-tracker-card .sht-actions{display:flex;flex-wrap:wrap;gap:12px;align-items:center}
        #sonark-hurricane-tracker-card .sht-button{display:inline-flex;align-items:center;justify-content:center;min-height:52px;padding:13px 22px;border-radius:999px;background:#ff8c1a;color:#06152f!important;font-weight:950;font-size:17px;text-decoration:none!important;border:2px solid transparent;transition:filter .15s ease,transform .15s ease}
        #sonark-hurricane-tracker-card .sht-button--secondary{background:#16c8f3;color:#06152f!important}
        #sonark-hurricane-tracker-card .sht-button:hover{filter:brightness(1.07);transform:translateY(-1px)}
        #sonark-hurricane-tracker-card .sht-button:focus-visible{outline:3px solid #fff;outline-offset:3px}
        #sonark-hurricane-tracker-card .sht-note{margin-top:14px!important;margin-bottom:0!important;font-size:13px!important;line-height:1.45!important;color:#b9d8e8!important}
        @media(max-width:900px){#sonark-hurricane-tracker-card .sht-card{grid-template-columns:1fr}#sonark-hurricane-tracker-card .sht-visual,#sonark-hurricane-tracker-card .sht-visual img{min-height:280px;max-height:420px}}
        @media(max-width:760px){#sonark-hurricane-tracker-card{padding:4px 14px 38px}#sonark-hurricane-tracker-card .sht-visual,#sonark-hurricane-tracker-card .sht-visual img{min-height:235px;max-height:300px}#sonark-hurricane-tracker-card .sht-copy{padding:30px 22px}#sonark-hurricane-tracker-card .sht-actions{display:grid;grid-template-columns:1fr;width:100%}#sonark-hurricane-tracker-card .sht-button{width:100%}#sonark-hurricane-tracker-card .sht-credit{left:12px;bottom:10px;font-size:11px!important}}
      </style>
      <article class="sht-card">
        <div class="sht-visual">
          <img src="https://cdn.shopify.com/s/files/1/0483/8922/6656/files/sonark-professional-hurricane-satellite.jpg?v=1784086037" alt="Satellite photograph of a hurricane over the Atlantic Ocean" loading="lazy" width="540" height="405">
          <p class="sht-credit">Satellite image: NASA Earth Observatory</p>
        </div>
        <div class="sht-copy">
          <p class="sht-eyebrow">Official NOAA Weather Resource</p>
          <h2>Track Hurricanes &amp; Tropical Weather</h2>
          <p class="sht-description">View the live NOAA outlook, marine forecast links, storm terminology, and a practical hurricane preparation checklist for boaters.</p>
          <div class="sht-actions">
            <a class="sht-button" href="/pages/hurricane-tracker">Open Hurricane Tracker &rarr;</a>
            <a class="sht-button sht-button--secondary" href="https://cdn.shopify.com/s/files/1/0483/8922/6656/files/sonark-hurricane-readiness-binder.pdf?v=1782357191" download="sonark-hurricane-readiness-binder.pdf">Download Hurricane Binder</a>
          </div>
          <p class="sht-note">Live weather links are provided by NOAA and the National Hurricane Center. The satellite photograph is illustrative and is not the current storm outlook.</p>
        </div>
      </article>`;

    anchorSection.insertAdjacentElement('afterend', wrapper);
  }

  ensureCanonicalLink();

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        ensureCanonicalLink();
        dropMarineGuidesDolphin(0);
        normalizeFooterDraftProductLink(0);
        replaceGearUpImage(0);
        addHurricaneTracker();
      },
      { once: true }
    );
  } else {
    dropMarineGuidesDolphin(0);
    normalizeFooterDraftProductLink(0);
    replaceGearUpImage(0);
    addHurricaneTracker();
  }
})();
